// CONSTANTS
import { colors } from 'constants/colors'

// MUI STYLES
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  panelContainer: {
    position: 'absolute',
    zIndex: 2,
    backgroundColor: 'white',
    borderRadius: 2,
    top: 16,
    left: 16,
    '& .MuiButtonGroup-grouped:not(:last-of-type)': {
      borderColor: theme.palette.divider,
    },
  },
  buttonGroupItem: {
    width: 40,
    height: 40,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  icon: {
    color: colors.icon.dark,
  },
}))

export default useStyles